import { useQueries } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetMultipleRewardsByOrganizationId = ({
  organizationIds,
}: {
  organizationIds: number[]
}) => {
  const apiCall = useTypedApiClient({
    path: '/le-connect/rewards-programs/organizations/{id}',
    method: 'get',
  })
  return useQueries({
    queries: organizationIds.map((organizationId) => {
      return {
        queryKey: ['get-rewards-by-org-id', organizationId],
        queryFn: async () => {
          const { data } = await apiCall({ id: organizationId })

          return data
        },
      }
    }),
  })
}
